import styled, { css } from 'styled-components'
import { Row } from '@/components/form'
import { colors, fontWeights } from '@/styles'

const OrRow = styled(Row)`
  justify-content: center;
  margin: 32px 0;
`

const OrText = styled.span`
  font-size: 14px;
  font-weight: ${fontWeights.medium};
  letter-spacing: -0.2px;
  line-height: 24px;
  color: ${colors.mediumGrey};
  width: 100%;

  :before,
  :after {
    background-color: ${colors.grey};
    content: '';
    display: inline-block;
    height: 1px;
    position: relative;
    vertical-align: middle;
    width: ${props => (props.justOr ? css`calc(50% - 35px)` : css`calc(50% - 94px)`)};
  }

  :before {
    right: ${props => (props.justOr ? '22px' : '10px')};
    margin-left: -50%;
  }

  :after {
    left: ${props => (props.justOr ? '22px' : '10px')};
    margin-right: -50%;
  }
`

const OrDiv = ({ orText, justOr = true }) => {
  return (
    <OrRow>
      <OrText justOr={justOr}>{orText}</OrText>
    </OrRow>
  )
}

export default OrDiv
